import type {BioIconProps} from './common-types'

export function ThunderDealIcon({fill = '#FF243E', ...attributes}: BioIconProps) {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M12.2117 1.78125C12.8775 1.78125 13.3232 2.413 13.1712 3.01863L13.1324 3.13975L11.4715 7.40208H13.4586C14.2384 7.40208 14.6714 8.2365 14.3294 8.86983L14.2503 8.99333L8.33652 16.9472C7.90902 17.5212 7.05323 17.1245 7.12765 16.4683L7.74911 10.9978H5.54194C4.8239 10.9978 4.36473 10.2663 4.62757 9.62429L4.63152 9.61558L7.72377 2.38925C7.79892 2.20945 7.92548 2.05583 8.08758 1.94767C8.24968 1.83951 8.44011 1.78161 8.63498 1.78125H12.2117Z"
        fill={fill}
      />
    </svg>
  )
}
